
export const startOfMonth = (date: Date) => {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export const endOfMonth = (date: Date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59) ;
}

export const startOfDay = (day: Date) => {
  const date = new Date(day);
  date.setHours(0, 0, 0, 0);
  return date;
}

export const endOfDay = (day: Date) => {
  const date = new Date(day);
  date.setHours(23, 59, 59, 59);
  return date;
}

export const dayMonthFormat = (date: Date) => date.toLocaleString('default', { month: 'short', day: 'numeric' });